export default __webpack_public_path__ + "static/media/vertical-align-bottom.d9184198.svg";